<template>
  <div >
     <game-int></game-int>
  </div>
</template>

<script>

import GameInt from '../components/GameInterface.vue'
export default {
  components: {
    GameInt
  }
}
</script>